import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "row items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_s_input = _resolveComponent("s-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_s_input, {
    ref: "refInputDate",
    modelValue: _ctx.innerValue,
    "onUpdate:modelValue": [
      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.innerValue) = $event)),
      _ctx.emitValue
    ],
    class: "s-input--date",
    placeholder: "ДД.ММ.ГГГГ",
    "clear-icon": "app:delete",
    readonly: _ctx.readonly,
    mask: _ctx.RU_MASK,
    required: _ctx.required,
    rules: _ctx.resultRules,
    "lazy-rules": _ctx.lazyRules,
    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.refInputDate.validate()))
  }, _createSlots({
    append: _withCtx(() => [
      _createVNode(_component_q_icon, {
        name: "app:date",
        class: "cursor-pointer s-input--date-icon"
      }, {
        default: _withCtx(() => [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_q_popup_proxy, {
                key: 0,
                ref: "datePickerPopup",
                cover: "",
                "transition-show": "scale",
                "transition-hide": "scale",
                class: "s-input--date-modal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_date, {
                    modelValue: _ctx.innerValue,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitValue() || _ctx.$refs.datePickerPopup.hide()))
                    ],
                    "today-btn": "",
                    mask: "DD.MM.YYYY",
                    readonly: _ctx.readonly
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _withDirectives(_createVNode(_component_s_btn, {
                          label: "Закрыть",
                          type: "light"
                        }, null, 512), [
                          [_directive_close_popup]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "readonly"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "append")
    ]),
    _: 2
  }, [
    _renderList(_ctx.filteredSlots, (_, slotName) => {
      return {
        name: slotName,
        fn: _withCtx(() => [
          _renderSlot(_ctx.$slots, slotName)
        ])
      }
    })
  ]), 1032, ["modelValue", "readonly", "mask", "required", "rules", "lazy-rules", "onUpdate:modelValue"]))
}